// src/components/RecaptchaField/RecaptchaField.jsx
import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import PropTypes from "prop-types";

const RecaptchaField = ({ onChange, siteKey, innerRef, className = "" }) => {
  return (
    <div className={`my-4 scale-[0.85] origin-left ${className}`}>
      <ReCAPTCHA sitekey={siteKey} onChange={onChange} ref={innerRef} />
    </div>
  );
};

RecaptchaField.propTypes = {
  onChange: PropTypes.func.isRequired,
  siteKey: PropTypes.string.isRequired,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  className: PropTypes.string,
};

export default RecaptchaField;
